<template>
  <div style="position:relative" id="export-modal">
    <div class="op-hover" style="position:absolute;right: 10px; top: 10px;z-index:999">
      <v-icon x-large color="primary" @click="search='';$emit('closeExportModal')">
        mdi-close
      </v-icon>
    </div>
    <v-card flat class="px-4 pb-16">
      <v-card-title class="py-8 pb-0 d-flex">
        <div>
          Export-Vorschau - {{ moment(this.month).locale('de').format('MMMM YYYY') }}
        </div>
      </v-card-title>
      <v-card-text class="body-1">
        <v-data-table
            v-if="statusReports.length > 0"
            :items="statusReports"
            :headers="headers"
            :items-per-page="10"
            :search="search"
            :footer-props="{
              'items-per-page-text': 'Einträge pro Seite',
              'items-per-page-all-text': 'Alle',
              'items-per-page-options': [10,20,30,50,-1]
            }"
        >
          <template v-slot:top>
            <v-row>
              <v-col cols="4">
                <v-text-field
                    v-model="search"
                    label="Suche "
                    clearable
                    style="max-width: 400px;"
                    class="mx-4"
                ></v-text-field>
              </v-col>
            </v-row>
          </template>

          <template v-slot:item.Leistungstext="{ item }">
            {{ item.Leistungstext }}
            <v-tooltip v-if="item.Nachricht" top class="body-2 py-1 px-2 ">
              <template v-slot:activator="{ on, attrs }">
                <v-hover v-slot="{ hover }" open-delay="0">
                  <v-icon color="'orange'" v-bind="attrs" size="22" v-on="on" style="margin-top: -2px;">
                    mdi-information-outline
                  </v-icon>
                </v-hover>
              </template>
              <div>
                <span style="font-size: 13px;">{{ item.Nachricht.titel }}<br>{{ item.Nachricht.text }}</span>
              </div>
            </v-tooltip>
          </template>

          <template v-slot:item.nexusStatus="{ item }">
            <div v-if="item.nexusStatus==='confirmed'">
              freigegeben
            </div>

            <div v-else-if="item.nexusStatus==='fetched'">
              übermittelt
              <span class="icon-kreis-haekchen text--primary"></span>
            </div>
          </template>

          <template v-slot:item.BewohnerID="{ item }">
            <v-chip
                v-if="!item.BewohnerID || item.BewohnerID == ''"
                color="red"
                dark
                small
            >
              fehlt
            </v-chip>
            <span v-else>
              {{ item.BewohnerID }}
            </span>
          </template>
          <template v-slot:item.LeistungsNummer="{ item }">
            <div class="d-flex justify-end">
              <v-btn
                  color="transparent"
                  @click="clickedEdit = item; addProductInfoModal = true"
                  depressed
                  class="mt-2 mb-2"
                  small
              >
                {{ item.LeistungsNummer }}
                <v-icon
                    color="grey"
                    small
                    right
                >mdi-pencil
                </v-icon>
              </v-btn>
            </div>
          </template>
          <template v-slot:item.superadmin="{ item }">
            <v-btn
                v-if="item.nexusStatusId && ($store.state.benutzer.info.superadmin === 1)"
                @click="deleteStatus(item.nexusStatusId)"
                x-small
                :disabled="isLoading"
                color="primary"
                dense
                depressed
            >
              Status löschen
            </v-btn>
          </template>
          <template v-slot:item.accountant="{ item }">
            <v-btn
                v-if="item.nexusStatusId && ($store.state.benutzer.info.accountant != undefined && $store.state.benutzer.info.accountant === 1 && $store.state.benutzer.info.superadmin != 1)"
                @click="deleteStatus(item.recordID)"
                x-small
                color="primary"
                dense
                depressed
                :disabled="isLoading"
            >
              Status löschen
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions style="display: block">
        <v-spacer></v-spacer>
        <v-row>
          <v-col cols="5">
            <div style="font-size: 13px;">
              *Preis: Betrag pro Abrechnungseinheit inkl. MwSt
              <span v-if="$store.state.benutzer.settings.zuschlag && $store.state.benutzer.settings.zuschlag > 0">und {{
                  $store.state.benutzer.settings.zuschlag
                }}% Admin-Zuschlag</span>
            </div>
            <div class="pl-6" v-if="isLoading">
              <v-progress-circular
                  indeterminate
                  color="primary"
              ></v-progress-circular>
              <span class="pl-8">
                Daten werden freigegeben...
              </span>
            </div>
          </v-col>
          <v-col cols="7">
            <div style="float:right;">
              <v-btn depressed class="mr-4" @click="search='';$emit('closeExportModal')">Fenster
                schliessen
              </v-btn>
              <v-btn class="primary"
                     :disabled="nNotConfirmed === 0 ||isLoading"
                     depressed @click="confirmAll">
                ({{ nNotConfirmed }}) Daten für NEXUS-Übermittlung freigeben
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="addProductInfoModal" persistent max-width="490">
      <product-lp-type-hint
          :key="'hint'+clickedEdit.LeistungsNummer+'_'+clickedEdit.ArtikelNrLAG"
          :curProdNameProp="clickedEdit.Leistungstext"
          :curProdId="clickedEdit.ArtikelNrLAG"
          :ownProdNoProp="clickedEdit.LeistungsNummer"
          @addProductInfo="addProductInfo"
          :showRemove="false"
          @abort="addProductInfoModal = false"
      />
    </v-dialog>
  </div>
</template>
<script>

import moment from 'moment'
import httpClient from "../../../utils/httpClient";
import ProductLpTypeHint from "../../products/ProductLpTypeHint";

export default {

  components: {
    ProductLpTypeHint
  },

  name: 'ExportPreview',
  emits: ['reload', 'closeExportModal', 'transferERP', 'exportERP',],
  props: ['report', 'bewohner', 'month', 'run', 'availableLeistungsnummern', 'inactiveLeistungsnummern'],

  data() {
    return {
      clickedEdit: {
        'LeistungsNummer': '',
        'Leistungstext': '',
        'ArtikelNrLAG': '',
      },
      benefitStatus: [],
      addProductInfoModal: false,
      moment: moment,
      search: '',
      isLoading: false,
      headers: [
        {text: 'NEXUS-STATUS', value: 'nexusStatus'},
        {text: 'BewohnerID', value: 'BewohnerID'},
        {text: 'Vorname', value: 'vorname'},
        {text: 'Name', value: 'name'},
        {text: 'LeistungsNummer', value: 'LeistungsNummer'},
        {text: 'Leistungstext', value: 'Leistungstext'},
        {text: 'Von', value: 'ErbringungsZeitraumDatumVon'},
        {text: 'Bis', value: 'ErbringungsZeitraumDatumBis'},
        {text: 'Menge', value: 'Menge'},
        {text: 'Einheit', value: 'Mengeneinheit'},
        {text: 'Preis*', value: 'Preis'},
        {text: 'MiGel-Code', value: 'MiGel-Code'},
        {text: 'GTIN', value: 'GTIN'},
        {text: 'Pharma-Code', value: 'Pharma-Code'}
      ]
    }
  },

  computed: {
    statusReports() {
      //Erste Zeile entfernen
      var rep = JSON.parse(JSON.stringify(this.report));
      const keys = rep.shift();

      var self = this;

      var tdata = rep.map(function (item) {

        const data = Object.assign.apply({}, keys.map((v, i) => ({[v]: item[i]})));

        var bew = self.bewohnerName(data.BewohnerID)

        var status = self.benefitStatus[data.LeistungsNummer + '_' + data.BewohnerID] != undefined ? self.benefitStatus[data.LeistungsNummer + '_' + data.BewohnerID].status : '';
        var recordID = self.benefitStatus[data.LeistungsNummer + '_' + data.BewohnerID] != undefined ? self.benefitStatus[data.LeistungsNummer + '_' + data.BewohnerID].id : -1;

        data.recordID = recordID
        data.name = bew.name
        data.vorname = bew.vorname
        data.status = status

        return data
      });


      return tdata
    },

    nNotConfirmed() {
      return this.statusReports.filter(item => !item.nexusStatus || item.nexusStatus === 'draft').length
    },
  },

  methods: {

    async addProductInfo(optionsObj) {
      this.addProductInfoModal = false;

      const res = await httpClient({
        url: process.env.VUE_APP_API_SHARED + 'save/prodinfo',
        method: 'post',
        data: {artnr: optionsObj.objectID, key: 'ownartno', value: optionsObj.ownProdNo}
      })

      this.$emit('exportERP');

      if (res.type == 'success') {
        this.addProductInfoModal = false;
      }
    },

    bewohnerName(externalID) {

      var bew = this.bewohner.filter(function (item) {
        return item.externalID == externalID
      })

      if (bew.length > 0) {
        return {
          'name': bew[0].name,
          'vorname': bew[0].vorname,
        }
      } else {
        return {
          'name': '',
          'vorname': '',
        }
      }
    },

    confirmAll() {
      this.$emit('transferERP')
    },

    async deleteStatus(id) {
      httpClient.delete(process.env.VUE_APP_API_CHECKLIST + 'erp/nexus-api/status/' + id)
          .then(response => {
            this.$emit('reload')
          })
    },
  },


  async mounted() {

    if (this.$store.state.benutzer.info.superadmin === 1) {
      this.headers.splice(5, 0,
          {text: 'Heim-Admin', value: 'superadmin'},
      )
    }

    if (this.$store.state.benutzer.info.accountant != undefined && this.$store.state.benutzer.info.accountant === 1 && this.$store.state.benutzer.info.superadmin != 1) {
      this.headers.splice(5, 0,
          {text: 'Heim-Admin', value: 'accountant'},
      )
    }
  },


}
</script>
<style lang="scss">
#export-modal {
  .v-data-table-header th {
    white-space: nowrap;
  }

  tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, .05);
  }
}

</style>